import * as Sentry from "@sentry/react";

// Sentry is enabled only for known deployed hostnames.
// The runtime hostname gate keeps local/dev copies and unexpected domains quiet.
const SENTRY_BY_HOST = {
  "edutest.vincita-sys.com": {
    environment: "test",
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
  },
  "hillside.s4dedunexus.com": {
    environment: "production",
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
  },
};

export function initSentry() {
  if (typeof window === "undefined") return;

  const config = SENTRY_BY_HOST[window.location.hostname];
  if (!config) return;

  Sentry.init({
    dsn: "https://fd3a5eacbd3be2af43024a43b9860081@o4511489839595520.ingest.us.sentry.io/4511512215683072",
    environment: config.environment,
    sendDefaultPii: config.sendDefaultPii,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: config.tracesSampleRate,
  });
}

export default initSentry;
